module.exports = __webpack_public_path__ + "static/media/dailanbueno.2e5058c9.jpeg";